const CTX_KEY = 'bf_catalog_ctx';
const RESULT_KEY = 'bf_catalog_result';
const REFRESH_KEY = 'bf_catalog_refresh';

export function markBotFarmaciaCatalogReturn(convId) {
  const id = String(convId || '').trim();
  if (id) sessionStorage.setItem(REFRESH_KEY, id);
}

export function readBotFarmaciaCatalogContext() {
  try {
    const raw = sessionStorage.getItem(CTX_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeBotFarmaciaCatalogContext(ctx) {
  sessionStorage.setItem(CTX_KEY, JSON.stringify(ctx));
}

export function writeBotFarmaciaCatalogResult(result) {
  sessionStorage.setItem(RESULT_KEY, JSON.stringify(result));
}

export function readBotFarmaciaCatalogResult() {
  try {
    const raw = sessionStorage.getItem(RESULT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearBotFarmaciaCatalogResult() {
  sessionStorage.removeItem(RESULT_KEY);
}

export function consumeBotFarmaciaCatalogResult() {
  const result = readBotFarmaciaCatalogResult();
  if (result) clearBotFarmaciaCatalogResult();
  return result;
}
